export const RegexEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
/**
 * at least 8 characters, but no more than 32, at least one digit [0-9], at
 * least one uppercase character [A-Z], at least one lowercase character [a-z],
 * at least one special character
 */
export const RegexPassword = /^((?=.*\d)(?=.*[A-Z])(?=.*\W).{8,32})$/;
export const RegexPhone = /^\d{10}$/;
export const RegexUrl = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
export const RegexOnlyLetters = /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s]+$/;
export const RegexOnlyNumbers = /^[0-9]+(\.[0-9]+)?$/;
